export const faqs = [
  {
    id: 'faq-01',
    group: '入口与访问',
    question: '爆料专区首页入口在哪里？',
    answer:
      '本站首页即为导航入口总览，你可以从首页的「快速入口」区域进入首页入口、最新爆料帖、热门讨论区与主题专区。建议把首页加入浏览器书签，之后一键直达。',
  },
  {
    id: 'faq-02',
    group: '入口与访问',
    question: '爆料专区网址和网页有什么区别？',
    answer:
      '网址指的是访问地址，网页指的是打开后看到的具体页面。同一个网址下会有首页、分类页、帖子页等不同网页，本站把它们按用途分门别类整理，方便按需查找。',
  },
  {
    id: 'faq-03',
    group: '入口与访问',
    question: '手机上可以正常访问吗？',
    answer:
      '可以。站点已做移动端适配，手机浏览器打开后导航会折叠为菜单按钮，内容自动改为单栏阅读，弱网环境下也能正常加载文字内容。',
  },
  {
    id: 'faq-04',
    group: '内容与判断',
    question: '站内的爆料内容一定真实吗？',
    answer:
      '不一定。爆料本质上属于未经官方确认的信息，本站会在编辑说明中标注信息来源与可信度区间，但仍然建议你把它当作线索参考，并自行通过官方渠道交叉验证后再形成判断。',
  },
  {
    id: 'faq-05',
    group: '内容与判断',
    question: '如何判断一条爆料是否值得关注？',
    answer:
      '可以从三点入手：信息来源是否单一、时间线是否完整、是否有可验证的旁证。信息越集中、时间线越清晰、旁证越多，通常越值得继续跟踪。',
  },
  {
    id: 'faq-06',
    group: '内容与判断',
    question: '热门讨论区的排序依据是什么？',
    answer:
      '排序综合考虑互动速度、跟帖深度与时间衰减三个维度。刚出现且讨论密集的话题排名会更靠前，长时间没有新互动的帖会逐渐下沉。',
  },
  {
    id: 'faq-07',
    group: '使用与互动',
    question: '可以提交自己的爆料线索吗？',
    answer:
      '可以。你可以在「关于我们」页面底部通过线索投稿表单提交，请尽量写清时间、地点与信息来源，方便编辑核对整理。',
  },
  {
    id: 'faq-08',
    group: '使用与互动',
    question: '如何第一时间收到更新？',
    answer:
      '首页与页脚都提供了更新订阅入口，填写邮箱后即可在每周更新时收到一次汇总提醒，不会频繁打扰。',
  },
  {
    id: 'faq-09',
    group: '使用与互动',
    question: '为什么有的内容没有配图？',
    answer:
      '部分话题涉及的事件仍在变化中，配图可能在短时间内失去时效性。这类内容会优先以文字与时间线呈现，待信息稳定后再补充图片。',
  },
];